import { useState, useEffect, useRef } from 'react';

// ¡Este hook escucha cuando la ventana cambia de tamaño!
const useContainerDimensions = () => {
  // 1. Referencia al elemento DOM que queremos medir
  const ref = useRef<HTMLDivElement>(null); 
  
  // 2. Estado para guardar el ancho y el alto
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    // 3. Función para leer las dimensiones reales del <div>
    const measure = (entry?: ResizeObserverEntry) => {
        // Usa el valor más reciente del entry, o el valor actual del DOM
        const element = entry ? entry.target as HTMLDivElement : ref.current;

        if (element) {
            setDimensions({
                width: element.clientWidth,
                height: element.clientHeight,
            });
        }
    };

    const resizeObserver = new ResizeObserver(entries => {
        if (entries[0].contentRect) {
            // Llama a measure directamente, sin debounce (sin setTimeout)
            measure(entries[0]); 
        }
    });

    // 3. Observar la referencia al montar
    if (ref.current) {
        measure(); // Medición inicial
        resizeObserver.observe(ref.current);
    }

    // 4. Limpieza
    return () => {
        resizeObserver.disconnect();
    };
  }, []); // Se ejecuta solo al montar/desmontar

  return { ref, dimensions };
};

export default useContainerDimensions;